<app-breadcrumb [master]="'Marketing'" [parentName]="'Wydania z magazynu'" [name]="'Lista'"></app-breadcrumb>
<div fxLayoutGap="15px" class="list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="list-filters">
    <mat-form-field class="list-filter">
      <mat-label>Numer</mat-label>
      <input matInput name="contains$number" [(ngModel)]="initialFilters.contains$number">
    </mat-form-field>

    <app-datepicker
      class="list-filter"
      label="Data utworzenia od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
    ></app-datepicker>

    <app-datepicker
      class="list-filter"
      label="Data utworzenia do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
    ></app-datepicker>

    <mat-form-field class="list-filter">
      <mat-label>Użytkownik</mat-label>
      <input matInput placeholder="Jan Kowalski" name="username" [(ngModel)]="initialFilters.username">
    </mat-form-field>

    <app-dict
      [multiple]="false"
      [dictType]="'wz_status'" [label]="'Status'"
      class="list-filter"
      [(ngModel)]="initialFilters.status" name="status"
    ></app-dict>

    <app-datepicker
      class="list-filter"
      label="Data wydania od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$releaseDate" name="gte$releaseDate"
    ></app-datepicker>

    <app-datepicker
      class="list-filter"
      label="Data wydania do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$releaseDate" name="lte$releaseDate"
    ></app-datepicker>
  </form>

  <div class="list-buttons">
    <button *ngIf="(userPermissions | async).marketing.read" (click)="downloadReport()" [disabled]="!(userPermissions | async).marketing.read"
            mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <table mat-table [dataSource]="dataSource">

    <ng-container matColumnDef="number">
      <th mat-header-cell *matHeaderCellDef> Numer </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/wyniki-konkursow/wydania-z-magazynu/szczegoly', element?.uuid]">{{element?.number ? element?.number : ""}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef> Data utworzenia </th>
      <td mat-cell *matCellDef="let element">
        {{element.createdAt | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="createdBy">
      <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.createdBy">
          <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', element.createdBy.uuid]">{{element.createdBy.firstName +' '+ element.createdBy.lastName}}</a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="totalAmount">
      <th mat-header-cell *matHeaderCellDef> Łączna liczba produktów </th>
      <td mat-cell *matCellDef="let element"> {{element.totalAmount}} </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status WZ </th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button [ngClass]="element?.status?.color + '-button'">{{element?.status?.name}}</button>
      </td>
    </ng-container>

    <ng-container matColumnDef="releaseDate">
      <th mat-header-cell *matHeaderCellDef> Data wydania </th>
      <td mat-cell *matCellDef="let element">
        {{element?.releaseDate | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
